import React, { Component } from 'react';
import { connect } from 'react-redux';
import './forms.css';
import * as repositoryActions from '../../../Store/Actions/repositoryActions';
import TextBox from '../TextBox/textbox';
import Button from '../Button/button';

/*
PARAMETERS :
  create : true/false
  object : {} // object to update or null if create = true,
  reservedValue : {COLUMNNAME:[ARRAY OF RESERVED VALUE]}
*/
class nace1Form extends Component {
  constructor(props) {
    super(props);
    // State is in reducers
    this.state = {
      create:true,
      endPoint:"EN3",
      blankObject:{
        AC_001: 0,
        ARCS: 0,
        ARCS_PER: 0,
        ARCS_TP_N3: 0,
        CODE: "",
        COMMENT: "",
        FLAG: 0,
        HISTORIQUE: 0,
        IU: "R",
        NSYS: 4,
        SIT: 0,
        Session: {},
        SessionIDE: "",
        Status: 0,
        WORDING: "",
      },
    };

  }

  // BUILDING METHOD DO NOT CHANGE
  componentDidMount = () =>{
    // GET THE OBJECT IF ID is provided
    if(this.props.id > 0){
      this.props.get_single_object(this.props.sessionId,this.props.id,this.state.endPoint);
      this.setState({create:false});
    }else{
      // ELSE CREATE BLANK OBJECT AND TRIGGER ON CREATE
      var blankObject = {...this.state.blankObject};
      blankObject.ARCS_TP_N3 = this.props.node.ARCS_TP_N3;
      this.setState({create:true});
      this.props.onCreateBlank(this.state.blankObject);
    }
  }


  // INNER METHOD 

  //GENERIC DO NOT CHANGE
  onClickCancel = () =>{
    this.props.onCancelForm();
  }

  // MAY CHANGE
  // ADD ALERT MANAGEMENT FOR UNIQUE REF
  onClickValid = () =>{
    var object = this.props.newObject;
    if(this.state.create){
      // CHECK RESERVED VALUE UNIQUE CODE
          if(this.props.dataSet.map(item=>item.CODE).includes(object.CODE)){
            alert("the value : "+object.CODE+ " should be unique and is already in use for column :"+"CODE");
          }else{
            this.props.onSave(object);
          }
    }else{
      this.props.onSave(object);
    }

  }

  //GENERIC DO NOT CHANGE
  onUpdateValue = (columnName,language,e) =>{
    var object = {...this.props.newObject};
    if(language !== undefined){
      object[columnName][language] = e;
    }else{
      object[columnName] = e;
    }
    
    this.setState({newObject:object});
  }

  render() {
    var content = this.props.newObject !== null ?
      <div>
        <div className="form-section">
          <div className="section-header">
            <span className="section-name">Identification (id : {this.state.create?0:this.props.newObject.ARCS})</span>
            <div className="section-status valid"></div>
          </div>
          <div className="section-body">
            <div className={!this.state.create ? "section-item column-2 readOnly": "section-item column-2"}>
            <label>Code</label>
            <TextBox 
              config={
                {
                  mask:null, 
                  color:"#999",
                  readOnly:this.state.create?false:true, 
                  maxLength:null, 
                  textAlign:"left"
                }
              }
              updateValue={this.onUpdateValue.bind(this,"CODE")}
              value = {this.props.newObject !== undefined? this.props.newObject["CODE"]:""}
            />
          </div>
            <div className="section-item column-2">
            <label>Comment</label>
            <TextBox 
              config={
                {
                  mask:null, 
                  color:"#999",
                  readOnly:false, 
                  maxLength:null, 
                  textAlign:"left"
                }
              }
              updateValue={this.onUpdateValue.bind(this,"COMMENT")}
              value = {this.props.newObject !== undefined?this.props.newObject["COMMENT"]:""}
            />
          </div>
            <div className="section-item column-2">
              <label>Wording ({this.props.language})</label>
              <TextBox 
                config={
                  {
                    mask:null, 
                    color:"#999",
                    readOnly:false, 
                    maxLength:null, 
                    textAlign:"left"
                  }
                } 
                updateValue={this.onUpdateValue.bind(this,"WORDING",this.props.language)}
                value = {this.props.newObject !== undefined? this.props.newObject["WORDING"]!==undefined?this.props.newObject["WORDING"][this.props.language]:"":""}
              />
            </div>
          </div>
        </div>
        <div className="form-section">
          <div>
              <Button 
                preventMultipleClick={0} 
                config={
                  {
                    isEnabled:true,
                    icon:"check",
                    text:"save change",
                    color:null,
                    textAlign:"center",
                    bgcolor:null
                  }
                } 
                OnClickElement={this.onClickValid.bind(this)}
              />
            </div>
        </div>
      </div>
    :
    null
    ;
    return (
      <div className="form-container" >
      {content}
      </div>
    );
  }
}

  const mapStateToProps = (state) => {    
    return {  
      newObject:state.apiReducer.newObject,
      sessionId: state.apiReducer.sessionId,
      dataSet:state.apiReducer.workingData,
      language:state.appReducer.language
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
      get_single_object: (sessionId,id,endPoint) =>dispatch(repositoryActions.get_single_object(sessionId,id,endPoint)),
      onUpdateValue:(columnName,e)=>dispatch(repositoryActions.onUpdateValue(columnName,e)),
      onCreateBlank:(object)=>dispatch(repositoryActions.onCreateBlank(object)),
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(nace1Form);